import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import config from '../config/config';

// eslint-disable-next-line react/prefer-stateless-function
const LinkLocalized = forwardRef((props, ref) => {
  const { intl, to, children } = props;
  const newTo = to.match(`/(${config.LOCALES.join('|')})/`) ? to : `/${intl.locale}${to}`;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Link {...props} to={newTo} ref={ref}>
      {children}
    </Link>
  );
});

LinkLocalized.propTypes = {
  to: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    locale: PropTypes.string,
  }).isRequired,
  children: PropTypes.element.isRequired,
};

// https://github.com/formatjs/react-intl/issues/1211
function withIntl(Component) {
  class Wrapper extends React.Component {
    render() {
      // eslint-disable-next-line react/prop-types
      const { innerRef, ...props } = this.props;
      return (
        <Component
          ref={innerRef}
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...props}
        />
      );
    }
  }

  const IntlWrapper = injectIntl(Wrapper);
  return forwardRef((props, ref) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <IntlWrapper {...props} innerRef={ref} />
  ));
}

export default withIntl(LinkLocalized);
